import { render, staticRenderFns } from "./OurPlans.vue?vue&type=template&id=45504b1b"
import script from "./OurPlans.vue?vue&type=script&lang=js"
export * from "./OurPlans.vue?vue&type=script&lang=js"
import style0 from "./OurPlans.vue?vue&type=style&index=0&id=45504b1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports